import { render, staticRenderFns } from "./clientTag.vue?vue&type=template&id=654d2aa5&scoped=true&"
import script from "./clientTag.vue?vue&type=script&lang=js&"
export * from "./clientTag.vue?vue&type=script&lang=js&"
import style0 from "./clientTag.vue?vue&type=style&index=0&id=654d2aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d2aa5",
  null
  
)

export default component.exports